import { useAxiosPrivate } from "./axios";

const LIST_QUERY = "/template/list";
const DETAIL_QUERY = "/template/detail";
const COPY_QUERY = "/template/copy";
const DELETE_QUERY = "/template/delete";
const CREATE_NEW_QUERY = "/template/create";
const UPDATE_QUERY = "/template/update";

export const useLoadTemplateById = () => {
  const getTemplate = async (id, callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(DETAIL_QUERY, {
        params: {
          id: id,
        },
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return getTemplate;
};

export const useSearchTemplates = () => {
  const searchTemplates = async (params, callback) => {
    const getUrlSearchParams = (params) => {
      const searchParam = {
        offset: params.offset,
        limit: params.limit,
      };
      if (params.name) {
        searchParam.name = params.name;
      }
      if (params.deleted !== null) {
        searchParam.deleted = params.deleted;
      }
      if (params.draft !== null) {
        searchParam.draft = params.draft;
      }
      return searchParam;
    };

    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(LIST_QUERY, {
        params: getUrlSearchParams(params),
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return searchTemplates;
};

export const useCopyTemplate = () => {
  const copyTemplate = async (template, callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.post(COPY_QUERY, template, {
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return copyTemplate;
};

export const useDeleteTemplateById = () => {
  const deleteTemplate = async (templateId, callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.delete(DELETE_QUERY, {
        data: templateId,
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return deleteTemplate;
};

export const useCreateTemplate = () => {
  const createTemplate = async (template, callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.post(CREATE_NEW_QUERY, template, {
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return createTemplate;
};

export const useUpdateTemplate = () => {
  const updateTemplate = async (template, callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.put(UPDATE_QUERY, template, {
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return updateTemplate;
};
